import { vservice } from '@niknevis/vue-modules'

@vservice()
export class Str {
  words(text: string, words: number) {
    return text
      .split(' ')
      .splice(0, words)
      .join(' ')
  }

  chars(text: string, chars: number) {
    return text.length > chars
      ? text
        .split('')
        .splice(0, chars)
        .join('')
        .concat('...')
      : text
  }

  format(str: string, args: any) {
    return str
      .replace(/{(.*?)}/ig, (_, key) => args[key])
  }

  toLocaleString(str: string, def?: string) {
    const number = Number(str)
    if (number !== number) {
      if (def) return def
      throw new Error(`Not a number ${str}`)
    }
    return number
      .toLocaleString()
  }
}
